import { IconProps } from '../../Interfaces/Props'

interface Props extends IconProps {
    IsLocked: boolean
}
const IconLock2 = (props: Props) => {
    if (props.IsLocked) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width={props.size ?? '24'} height={props.size ?? '24'} viewBox="0 0 24 24"><path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z" /></svg>
        )
    } else {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width={props.size ?? '24'} height={props.size ?? '24'} viewBox="0 0 24 24"><path fill="currentColor" d="M12 13c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m6-5h-1V6c0-2.76-2.24-5-5-5c-2.28 0-4.27 1.54-4.84 3.75c-.14.54.18 1.08.72 1.22a1 1 0 0 0 1.22-.72A2.996 2.996 0 0 1 12 3c1.65 0 3 1.35 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 11c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1z" /></svg>
        )
    }
}

export default IconLock2